import { t } from "i18next";
import apiClient from "../api/axios";
import { handleApiError } from "../api/handleApiError";
import {
  TemplateActivities,
  TemplateActivitiesResponse,
} from "../models/TemplateActivities";
import { ResponseTemplateActivities } from "../models/dto/response/ResponseTemplateActivities";

const TemplateActivitiesService = {
  getTemplateActivities: async (): Promise<TemplateActivities[] | null> => {
    try {
      const response = await apiClient.get("/v1/template-activities");

      if (response.status === 200) {
        const result: TemplateActivitiesResponse = response.data;
        return result.results.templateActivities;
      }
    } catch (error: any) {
      handleError(error);
    }
    return null;
  },
  updateIsMonthlyTemplateActivity: async (
    refId: string,
    isMonthly: boolean,
  ) => {
    const body = { isMonthly };

    try {
      const response = await apiClient.patch(
        `/v1/template-activities/${refId}`,
        body,
      );
      if (response.status === 200) {
        const result: TemplateActivitiesResponse = response.data;
        return result.results.templateActivities;
      }
    } catch (error: any) {
      handleError(error);
    }
    return null;
  },
  deleteTemplateActivity: async (refId: string) => {
    const body = { isDelete: true };

    try {
      const response = await apiClient.patch(
        `/v1/template-activities/${refId}`,
        body,
      );

      if (response.status === 200) {
        const result: TemplateActivitiesResponse = response.data;
        return result.results.templateActivities;
      }
    } catch (error: any) {
      handleError(error);
    }
    return null;
  },
  createTemplateActivities: async (
    formData: any,
  ): Promise<ResponseTemplateActivities | null> => {
    try {
      const response = await apiClient.post(
        "/v2/template-activities",
        formData,
      );
      if (response.status === 200 || response.status === 201) {
        return response.data.results;
      }
    } catch (error: any) {
      handleError(error, formData.year);
    }
    return null;
  },
  monthlyRegenerateTemplateActivities:
    async (): Promise<ResponseTemplateActivities | null> => {
      try {
        const response = await apiClient.post(
          "/v1/template-activities/monthly-regenerate",
        );
        if (response.status === 200 || response.status === 201) {
          return response.data.results;
        }
      } catch (error: any) {
        handleError(error);
      }
      return null;
    },
  editTemplateActivities: async (
    formData: any,
    refId: string,
  ): Promise<ResponseTemplateActivities | null> => {
    try {
      const response = await apiClient.put(
        `/v2/template-activities/${refId}`,
        formData,
      );
      if (response.status === 200 || response.status === 201) {
        return response.data.results;
      }
    } catch (error: any) {
      handleError(error, formData.year);
    }
    return null;
  },
};

const handleError = (error: unknown, year?: number) =>
  handleApiError(
    error,
    {
      TEMPLATE_ACTIVITY_ALREADY_EXISTS: {
        messageKey: () => t("template_activity_already_exists", { year }),
        type: "error",
      },
      FORBIDDEN_UPDATE_RESTRICTED_FIELDS: {
        messageKey: "Forbidden-Update-Restricted-Fields",
        type: "info",
      },
      FORBIDDEN_NOT_CREATOR: "Only-Creator-Or-Admin",
      RESOURCE_NOT_FOUND: "Template-Activity-Not-Found",
    },
    "Cannot-Access-Organization-Error",
  );

export default TemplateActivitiesService;
